import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module7Nav = () => {
  const { module7 } = useSelector((state) => state.module7, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage = '/Module7Images/JourneyMap7.png';
    const mobileImage = '/Module7Images/Module7NavImages/Background_Unit2_Mod2_JourneyMap.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module7Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+3.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module7Images/Module7NavImages/JourneyMap_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module7Images/Module7NavImages/JourneyMap_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/answer',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/answer/answer_full_song_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/answer_affirmation.mp4`,
      `userfiles/${module7.StudentID}/answer_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid}/answer_affirmation.mp4`,
      'appfiles/answer/answer_greeting_5.mp4',
      `userfiles/${module7.StudentID}/greet_practice_video_5.mp4`,
      'appfiles/answer/answer_question_5.mp4',
      `userfiles/${module7.StudentID}/answer_practice_video_5.mp4`,
      'appfiles/answer/answer_acknowledge_5.mp4',
      `influencers/${login.influencerid}/answer_video_message.mp4`,
      `influencers/${login.influencerid}/answer_affirmation.mp4`,
      `userfiles/${module7.StudentID}/answer_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid}/answer_affirmation.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE7'
          module={module7}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit2'
          nextDestiny='/unit2'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={2}
          animal={MediaService.getImage('/Images/Button_DogHead.png', login)}
        />
      )}
    </>
  );
};
export default Module7Nav;
